// @flow
import * as React from 'react';
import { compose } from 'redux';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { withGoogleReCaptcha } from '@dpdgroupuk/react-google-recaptcha-v3';
import { withProps } from 'recompose';

import { withCollection } from '../Collection/hocs';
import ChangeCollectionOption from '../ChangeCollectionOption';
import CollectionOptions from './CollectionOptions';
import { fetchCollectionActions } from './actions';
import { ACTION } from '../../constants/recaptcha';
import withFetch from '../../HOCs/withFetch';

const CollectionOptionsRouter = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path} component={CollectionOptions} />
      <Route component={ChangeCollectionOption} />
    </Switch>
  );
};

export default compose(
  withCollection,
  withGoogleReCaptcha,
  withProps(({ match, reCaptchaConfig }) => ({
    fetchCollectionActionsWithRecaptcha: async dispatch => {
      const token = await reCaptchaConfig.executeRecaptchaAsync(
        ACTION.GET_COLLECTION
      );
      return dispatch(fetchCollectionActions({ match }, token));
    },
  })),
  withFetch(props => props.fetchCollectionActionsWithRecaptcha)
)(CollectionOptionsRouter);
